import React from 'react';
import { FiPlay, FiCalendar, FiClock, FiPause } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useAudio } from '../context/AudioContext';

const EpisodeCard = ({ episode, episodeList }) => {
  const { currentEpisode, isPlaying, playEpisode } = useAudio();
  
  const isActive = currentEpisode?.title === episode.title;

  return (
    <div 
      className={`bg-white rounded-lg overflow-hidden border transition-all duration-500 flex flex-col h-full group ${
        isActive 
          ? 'border-brand-tan shadow-lg ring-1 ring-brand-tan/20' 
          : 'border-brand-green/10 hover:border-brand-tan/30 hover:shadow-md'
      }`}
    >
      {/* Top Metadata Strip */}
      <div className={`px-4 py-2 border-b flex justify-between items-center transition-colors ${
        isActive ? 'bg-brand-tan/5 border-brand-tan/10' : 'bg-brand-cream/50 border-brand-green/5'
      }`}>
        <div className="flex items-center gap-2 text-brand-tan font-bold text-[9px] tracking-widest uppercase">
          <SafeIcon icon={FiCalendar} className="w-3 h-3" />
          <span>{episode.pubDate}</span>
        </div>
        <div className="flex items-center gap-2 text-brand-green/60 font-semibold text-[9px] tracking-widest uppercase">
          <SafeIcon icon={FiClock} className="w-3 h-3" />
          <span>{episode.duration}</span>
        </div>
      </div>

      <div className="p-4 flex flex-col flex-grow">
        <h3 className={`text-base font-bold mb-2 line-clamp-2 leading-tight transition-colors font-serif ${
          isActive ? 'text-brand-tan' : 'text-brand-dark group-hover:text-brand-tan'
        }`}>
          {episode.title}
        </h3>
        
        <p className="text-xs text-brand-green/80 line-clamp-2 mb-4 leading-relaxed flex-grow">
          {episode.description}
        </p>

        <div className="flex items-center gap-3 mt-auto">
          <button 
            onClick={() => playEpisode(episode, episodeList)} // Pass the full list!
            className={`flex-grow inline-flex items-center justify-center gap-2 py-2 px-3 rounded text-[10px] font-bold uppercase tracking-widest transition-all duration-300 ${
              isActive && isPlaying 
                ? 'bg-brand-tan text-white' 
                : 'bg-brand-dark hover:bg-brand-tan text-white'
            }`}
          >
            <SafeIcon icon={(isActive && isPlaying) ? FiPause : FiPlay} className="fill-current w-3 h-3" />
            <span>{(isActive && isPlaying) ? 'Playing' : 'Play'}</span>
          </button>
          
          {/* Subtle thumbnail */}
          <div className="w-8 h-8 rounded overflow-hidden flex-shrink-0 border border-brand-green/10 bg-brand-cream">
            <img 
              src={episode.image} 
              alt="" 
              className={`w-full h-full object-cover transition-all duration-500 ${
                isActive ? 'grayscale-0 scale-110' : 'grayscale group-hover:grayscale-0'
              }`} 
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EpisodeCard;